import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import { trackEvent } from 'dibs-tracking';
import BuyerAssurance from 'dibs-vg/dist/react/buyer-assurance';
import { PageLayout } from 'dibs-elements/exports/PageLayout';
import { RenderIn, device } from '../../utils/RenderIn';

import { HomePageContext } from '../HomePageContext';
import { connectContext } from '../../context/helpers/connectContext';

import styles from './HpRespInformationalContent.scss';

const trackCtaClick = ({ isDesktop }) => {
    trackEvent({
        category: 'navigation',
        action: `learn more ${isDesktop ? 'link' : 'banner'} clicked`,
        label: 'homepage',
    });
};

const HpRespInformationalContent = ({ isDesktop, viewer }) => {
    const data = get(viewer, 'informationalContent') || {};

    if (!data.visible) {
        return null;
    }

    const { title, benefits, ctaText, ctaUrl, ctaTitle } = data;

    return (
        <PageLayout setViewportBackground={'sassyColorBuyerTertiary'}>
            <div className={styles.wrapper}>
                <div className={styles.title}>{title}</div>

                <RenderIn deviceTypes={[device.DESKTOP]}>
                    <div className={styles.benefitsWrapper}>
                        {benefits.map((benefit, index) => (
                            <span key={index} className={styles.benefit}>
                                <BuyerAssurance className={styles.icon} />
                                {benefit}
                            </span>
                        ))}
                    </div>
                </RenderIn>

                <RenderIn deviceTypes={[device.TABLET, device.MOBILE]}>
                    <span className={styles.benefitsWrapper}>
                        {benefits.map((benefit, index) => (
                            <React.Fragment key={index}>
                                {benefit}
                                {index < benefits.length - 2 && ', '}
                                {index === benefits.length - 2 && (
                                    <React.Fragment> &amp; </React.Fragment>
                                )}
                            </React.Fragment>
                        ))}
                    </span>
                </RenderIn>

                <a
                    className={styles.cta}
                    href={ctaUrl}
                    title={ctaTitle}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                        trackCtaClick({ isDesktop });
                    }}
                >
                    {ctaText}
                </a>
            </div>
        </PageLayout>
    );
};

HpRespInformationalContent.propTypes = {
    viewer: PropTypes.object.isRequired,
    isDesktop: PropTypes.bool,
};

const mapContextToProps = ({ isDesktop }) => {
    return { isDesktop };
};

const HpRespInformationalContentWithContext = connectContext(HomePageContext, mapContextToProps)(
    HpRespInformationalContent
);

export const HpRespInformationalContentRelayContainer = createFragmentContainer(
    HpRespInformationalContentWithContext,
    {
        viewer: graphql`
            fragment HpRespInformationalContent_viewer on Viewer {
                informationalContent @skip(if: $isTrade) {
                    visible
                    title
                    benefits
                    ctaText
                    ctaUrl
                    ctaTitle
                }
            }
        `,
    }
);
